import React, { FC } from 'react';

import { SidebarNodeContext } from 'src/v2/modules/layout/contexts/SidebarNodeContext';

import { ProfileSidebar } from './profileSidebar';

export const SidebarNodeContextProvider: FC = ({ children }) => (
  <SidebarNodeContext.Provider value={<ProfileSidebar />}>{children}</SidebarNodeContext.Provider>
);
